export default __webpack_public_path__ + "static/media/kids.da99b2df.JPG";